import type { LogoutOptions } from '@auth0/auth0-react'

type LogoutFn = (options?: LogoutOptions) => Promise<void>

let inFlight: Promise<void> | null = null

/**
 * Collapse the several uncoordinated `logout()` call sites (AuthErrorBoundary,
 * the 401 response interceptor, the login page) into a single call per failure.
 * Without this, a dead session triggers multiple logouts plus a render-vs-effect
 * redirect race, producing the console burst and login-page flicker.
 *
 * The in-flight promise is cleared once logout settles so a later session in the
 * same SPA instance (re-login → expire again) is handled independently.
 */
export const singleFlightLogout = (logout: LogoutFn, options?: LogoutOptions): Promise<void> => {
  if (inFlight) {
    return inFlight
  }

  inFlight = Promise.resolve(logout(options)).finally(() => {
    inFlight = null
  })

  return inFlight
}

/** Test-only: clear the in-flight guard between cases. */
export const resetSingleFlightLogout = () => {
  inFlight = null
}
